var map = {
	"./de.json": 357,
	"./en.json": 358,
	"./es.json": 359,
	"./fr.json": 360,
	"./it.json": 361,
	"./skins/class.it.json": 630,
	"./skins/default.en.json": 631,
	"./skins/education.de.json": 632,
	"./skins/education.en.json": 633,
	"./skins/education.es.json": 634,
	"./skins/education.fr.json": 635,
	"./skins/education.it.json": 636,
	"./skins/museum.de.json": 637,
	"./skins/museum.en.json": 638,
	"./skins/museum.es.json": 639,
	"./skins/museum.fr.json": 640,
	"./skins/museum.it.json": 641,
	"./tenants/ancot.it.json": 642,
	"./tenants/class.it.json": 643,
	"./tenants/csp.en.json": 644,
	"./tenants/csp.it.json": 645,
	"./tenants/ekom.it.json": 646
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 629;